import { TimePicker } from "@progress/kendo-react-dateinputs";
import { Popup, PopupProps } from "@progress/kendo-react-popup";
import moment from "moment";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import SweetAlertService from "../../../../services/SweetAlertService";
import { errorMessagesForWorkHourDetails, getRequiredErrorMessage } from "../../Shared/Constants/AdminModuleConstants";
import WorkHourService from "../../Shared/Services/WorkHourService";
import { WorkHourDetails } from "../Models/workHour";

export const UpdateWorkHourDetails = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { control, setValue, getValues, handleSubmit, reset, formState: { errors } } = useForm();
    const [workHourDetails, setWorkHourDetails] = useState<WorkHourDetails>();

    useEffect(() => {
        getWorkhourDetailsBuID();
    }, []);

    const getDateObject = (timeString: any) => {
        const [hours, minutes] = timeString.split(':');
        const date = new Date();
        date.setHours(Number(hours));
        date.setMinutes(Number(minutes));
        return date;
    }

    const getWorkhourDetailsBuID = () => {
        WorkHourService.getWorkHourDetailsById(Number(id)).then((response: any) => {
            setWorkHourDetails(response.data);
            setValue("startTime", getDateObject(response.data.startTime));
            setValue("endTime", getDateObject(response.data.endTime));
            setValue("sessionLength", getDateObject(response.data.sessionLength));
            setValue("workHourTypeName", response.data.workHourTypeName);
            setValue("workHourTypeId", Number(response.data.workHourTypeId));
            setValue("workHourId", Number(response.data.workHourId));
        }).catch(() => {
            SweetAlertService.error("Error", `Something went wrong while getting session rate by id ${id}`);
        })
    }

    const CustomPopup = (props: PopupProps) => {
        return (
            <Popup
                {...props}
                anchorAlign={{
                    horizontal: 'left',
                    vertical: 'top',
                }}
                popupAlign={{
                    horizontal: 'left',
                    vertical: 'top',
                }}
            />
        );
    };

    const onformSubmit = (data: any) => {
        data.workHourId = data.workHourId;
        data.startTime = moment(data.startTime).format('HH:mm');
        data.endTime = moment(data.endTime).format('HH:mm');
        data.sessionLength = moment(data.sessionLength).format('HH:mm');
        data.workHourTypeId = data.workHourTypeId;
        data.id = Number(id);
        WorkHourService.updateWorkHourDetails(data.id, data).then((response) => {
            if (response) {
                //Reset form
                reset();
                navigate(`/workhourDetails/${data.workHourId}`);
            } else {
                console.log("Error : Something went wrong while updating session rate" + data);
            }
        }).catch(error => {
            if (error) {
                SweetAlertService.error("Error", error.response.data);
            }
        })
    }

    return (
        <div className="card card-default">
            <div className="card-header">
                <h4>Edit Session rate</h4>
            </div>
            <div className="card-body">
                <form onSubmit={handleSubmit(onformSubmit)}>
                    <div className="form-group row">
                        <label className="col-lg-3 control-label">
                            Work Hour Type
                        </label>
                        <div className="col-lg-9">
                            <label className="col-lg-3 control-label">
                                {workHourDetails?.workHourTypeName}
                            </label>
                        </div>
                    </div><br />
                    <div className=" form-group row">
                        <label className="col-lg-3 control-label justify-content-center">
                            Start Time
                        </label>
                        <div className="col-lg-9">
                            <Controller
                                name="startTime"
                                control={control}
                                rules={{ required: getRequiredErrorMessage("Start time") }}
                                render={({ field }) => (
                                    <TimePicker
                                        id="startTime"
                                        {...field}
                                        format="HH:mm"
                                        popup={CustomPopup}
                                        onChange={(event: any) => field.onChange(event.value)}
                                        onBlur={field.onBlur}
                                    />
                                )}
                            />
                            {errors.startTime &&
                                (<span className="help-block m-b-none text-danger field-validation-valid">
                                    {errors.startTime.message?.toString()}
                                </span>
                                )}
                        </div>
                    </div><br />
                    <div className=" form-group row">
                        <label className="col-lg-3 control-label justify-content-center">
                            End Time
                        </label>
                        <div className="col-lg-9">
                            <Controller
                                name="endTime"
                                control={control}
                                rules={{ required: getRequiredErrorMessage("End time") }}
                                render={({ field }) => (
                                    <TimePicker
                                        id="endTime"
                                        {...field}
                                        format="HH:mm"
                                        onChange={(event: any) => field.onChange(event.value)}
                                        onBlur={field.onBlur}
                                    />
                                )}
                            />
                            {errors.endTime && (
                                <span className="help-block m-b-none text-danger field-validation-valid">
                                    {errors.endTime.message?.toString()}
                                </span>
                            )}
                        </div>
                    </div><br />
                    <div className=" form-group row">
                        <label className="col-lg-3 control-label justify-content-center">
                            Session Length
                        </label>
                        <div className="col-lg-9">
                            <Controller
                                name="sessionLength"
                                control={control}
                                rules={{ required: getRequiredErrorMessage("Session length") }}
                                render={({ field }) => (
                                    <TimePicker
                                        id="sessionLength"
                                        {...field}
                                        format="HH:mm"
                                        onChange={(event: any) => field.onChange(event.value)}
                                        onBlur={field.onBlur}
                                    />
                                )}
                            />
                            {errors.sessionLength && (
                                <span className="help-block m-b-none text-danger field-validation-valid">
                                    {errors.sessionLength.message?.toString()}
                                </span>
                            )}
                        </div>
                    </div>
                    <br />
                    <div className="form-group row">
                        <div className=" col-sm-offset-3 px-2">
                            <a className="btn btn-secondary"
                                onClick={() => navigate(`/workhourDetails/${workHourDetails?.workHourId}`)}>
                                Cancel
                            </a>
                            <button className="btn btn-primary ms-1"
                                type="submit">
                                Update
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}